<prlw-all-table-tabs class="tabs-container">
  <prlw-all-table-tab-item [label]="getLabel('basic')">
    <prlw-all-table-tab-label>Базовая цена</prlw-all-table-tab-label>
  </prlw-all-table-tab-item>
  <prlw-all-table-tab-item
    [label]="getLabel('simple')"
    [disabled]="isDisabled$('simple') | async"
  >
    <prlw-all-table-tab-label>Простая цена</prlw-all-table-tab-label>
  </prlw-all-table-tab-item>
  <prlw-all-table-tab-item
    [label]="getLabel('prepaid')"
    [disabled]="isDisabled$('prepaid') | async"
  >
    <prlw-all-table-tab-label>По предоплате</prlw-all-table-tab-label>
    <prlw-all-table-tab-body class="tab-body">
      <div class="input-container">
        <input
          [formControl]="prepaidMargin"
          class="modifiers-input"
          pattern="^-?\d*[,]{0,1}\d{0,2}$"
          oninput="!validity.patternMismatch || (value=value.slice(0,-1))"
          placeholder="Введите маржу, &#8381;"
        />
        <prlw-icon
          class="cross"
          name="close-cross"
          (click)="resetPrepaidMargin()"
        ></prlw-icon>
      </div>
    </prlw-all-table-tab-body>
  </prlw-all-table-tab-item>
  <prlw-all-table-tab-item
    [label]="getLabel('defer')"
    [disabled]="isDisabled$('defer') | async"
  >
    <prlw-all-table-tab-label>С отсрочкой платежа</prlw-all-table-tab-label>
    <prlw-all-table-tab-body class="tab-body">
      <div class="input-container">
        <input
          [formControl]="deferPercent"
          class="modifiers-input"
          pattern="^-?\d*[,]{0,1}\d{0,2}$"
          oninput="!validity.patternMismatch || (value=value.slice(0,-1))"
          placeholder="Процент годовых"
        />
        <prlw-icon
          class="cross"
          name="close-cross"
          (click)="resetDeferPercent()"
        ></prlw-icon>
      </div>
      <div class="input-container">
        <input
          [formControl]="deferPeriod"
          class="modifiers-input"
          placeholder="Дней отсрочки"
          pattern="^\d*$"
          oninput="!validity.patternMismatch || (value=value.slice(0,-1))"
        />
        <prlw-icon
          class="cross"
          name="close-cross"
          (click)="resetDeferPeriod()"
        ></prlw-icon>
      </div>
    </prlw-all-table-tab-body>
  </prlw-all-table-tab-item>
</prlw-all-table-tabs>
<div
  class="color-corner"
  [class.passive-color-corner]="tabs?.activeTab?.label !== BASIC_TAB_LABEL"
></div>
